<div *ngIf="collection">
    <div class="mb:pb-24">
        <vsf-section-nav-menu
            [isMobile]="isMobile"
            [showTopNav]="showTopNav"
            [isHeaderFloating]="isHeaderFloating"
            [withHeaderMessage]="withHeaderMessage"
            [navigationMenu]="navigationMenu"
            (navItemClicked)="scrollToSection($event)"
        ></vsf-section-nav-menu>
        <h1 *ngIf="h1CustomText && h1StyleMode !== 'sr-only'"
            [innerHTML]="h1CustomText | safeHtml"
            [ngStyle]="h1CustomStyles"
            class="page-h1-heading px-4 py-2 text-3xl font-bold"></h1>
        <h1 *ngIf="h1CustomText && h1StyleMode === 'sr-only'"
            class="sr-only">{{ h1CustomText }}</h1>
        <ng-container *ngIf="pagecomponentList.length > 0">
            <div *ngFor="let component of pagecomponentList; let i = index" [ngStyle]="layoutOrder[i].styles" [id]="component.sectionId">
                <ng-container *ngIf="component.type === 'product-listing-section'; else otherComponent">
                    <vsf-product-list
                        [channelId]="sellerChannelId"
                        [needItemListSchema]="true"
                        [linePadding]="layoutOrder[i].linePadding"
                        (itemListSchemaReady)="onItemListSchemaReady($event)"
                    >
                    </vsf-product-list>
                </ng-container>
                <ng-template #otherComponent>
                    <vsf-page-component
                        [pageComponent]="component"
                        [linePadding]="layoutOrder[i].linePadding"
                        [horizontalPadding]="layoutOrder[i].horizontalPadding"
                        [sectionRoundedClass]="layoutOrder[i].roundedClass"
                        [isMobile]="isMobile"
                        [sellerChannelId]="sellerChannelId"
                        [pdpAssetsArrowType]="pdpAssetsArrowType"
                        [pageFullWidth]="layoutOrder[i].pageFullWidth ?? false"
                        [sectionMaxHeight]="layoutOrder[i].sectionMaxHeight || ''"
                        [isPageHeading]="i === h1PageHeadingIndex"
                        [h1StyleMode]="h1StyleMode">
                    </vsf-page-component>
                </ng-template>
            </div>
        </ng-container>
    </div>
</div>

